(function () {
  const STORAGE_KEY = "breadcrumb-collection";
  const PENDING_KEY = "breadcrumb-collection-pending";

  const nav = document.getElementById("product-breadcrumb");

  // Always reveal the breadcrumb when done — prevents FOUC caused by the
  // server-rendered stateless breadcrumb painting before this script runs.
  const reveal = () => {
    if (nav) nav.removeAttribute("data-breadcrumb-loading");
  };

  // Safety net: if something goes wrong and reveal() is never called, show
  // the breadcrumb after 300ms so it doesn't stay hidden on slow connections.
  const safetyTimer = setTimeout(reveal, 300);

  try {
    // Only replace the breadcrumb if this page load was the immediate result of a
    // product card click from a collection page or a Shopify Page. The pending flag
    // is written by the product card click handler and consumed here (one-time use).
    // Without it, direct URL access, page refresh, and navigations from other surfaces
    // (search, carousels, recommendations) all show the server-rendered stateless
    // breadcrumb unchanged.
    const pending = sessionStorage.getItem(PENDING_KEY);
    if (!pending) {
      clearTimeout(safetyTimer);
      reveal();
      return;
    }

    sessionStorage.removeItem(PENDING_KEY);

    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      clearTimeout(safetyTimer);
      reveal();
      return;
    }

    const { type, handle, title } = JSON.parse(raw);
    if (!handle || !title || !nav) {
      clearTimeout(safetyTimer);
      reveal();
      return;
    }

    // Default to 'collection' when type is missing — preserves behaviour for any
    // in-flight stored entry written before this change shipped.
    const pathPrefix = type === "page" ? "/pages/" : "/collections/";

    const ol = nav.querySelector("ol");
    if (!ol) {
      clearTimeout(safetyTimer);
      reveal();
      return;
    }

    // Source context wins when the user just clicked through from a collection page
    // or a Shopify Page. The server-rendered category items (from loki_product
    // metafields or the product.category fallback) are replaced with the originating
    // collection or page so the breadcrumb reflects the user's actual navigation
    // path. Direct URL visits, search, and carousel clicks have no pending flag so
    // this code never runs on those surfaces — the server-rendered metafield
    // hierarchy remains untouched.
    const categoryItems = ol.querySelectorAll("[data-breadcrumb-category]");

    const typePreset = nav.dataset.typePreset || "";
    const hideCurrentPage = nav.dataset.hideCurrentPage === "true";
    const shopUrl = nav.dataset.shopUrl || "";

    // Build the replacement <li> for the originating collection or page
    const li = document.createElement("li");
    li.className = `flex items-center ${typePreset}`.trim();
    li.setAttribute("itemprop", "itemListElement");
    li.setAttribute("itemscope", "");
    li.setAttribute("itemtype", "https://schema.org/ListItem");
    li.setAttribute("data-breadcrumb-category", "");

    const a = document.createElement("a");
    a.setAttribute("itemprop", "item");
    a.href = `${shopUrl}${pathPrefix}${handle}`;
    a.className = "hover:text-gray-700";

    const nameSpan = document.createElement("span");
    nameSpan.setAttribute("itemprop", "name");
    nameSpan.textContent = title;
    a.appendChild(nameSpan);
    li.appendChild(a);

    const positionMeta = document.createElement("meta");
    positionMeta.setAttribute("itemprop", "position");
    positionMeta.setAttribute("content", "2");
    li.appendChild(positionMeta);

    // Clone the separator from the server-rendered template (respects section settings)
    if (!hideCurrentPage) {
      const separatorTemplate = document.getElementById(
        "breadcrumb-separator-template",
      );
      if (separatorTemplate) {
        li.appendChild(separatorTemplate.content.cloneNode(true));
      }
    }

    // Replace all existing category items with the single source item (collection or page).
    // If none exist (edge case), anchor before the last li (the product-title item).
    const anchor = categoryItems[0] || ol.lastElementChild;
    ol.insertBefore(li, anchor);
    categoryItems.forEach((item) => item.remove());

    // Recalculate position values for all breadcrumb items
    ol.querySelectorAll('li[itemprop="itemListElement"]').forEach(
      (item, index) => {
        const meta = item.querySelector('meta[itemprop="position"]');
        if (meta) meta.setAttribute("content", String(index + 1));
      },
    );
  } catch (e) {
    // Any failure: server-rendered stateless breadcrumb remains untouched
  }

  clearTimeout(safetyTimer);
  reveal();
})();
